/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Profile_Parq_ValueInputs */

const en_us2_profile_parq_value = /** @type {(inputs: Profile_Parq_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Answered on ${i?.date}`)
};

const pt_br2_profile_parq_value = /** @type {(inputs: Profile_Parq_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Respondido em ${i?.date}`)
};

const es_419_profile_parq_value = /** @type {(inputs: Profile_Parq_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Respondido el ${i?.date}`)
};

const pt_pt2_profile_parq_value = /** @type {(inputs: Profile_Parq_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Respondido a ${i?.date}`)
};

const fr_fr2_profile_parq_value = /** @type {(inputs: Profile_Parq_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Répondu le ${i?.date}`)
};

const de_de2_profile_parq_value = /** @type {(inputs: Profile_Parq_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beantwortet am ${i?.date}`)
};

const it_it2_profile_parq_value = /** @type {(inputs: Profile_Parq_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Compilato il ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Answered on {date}" |
*
* @param {Profile_Parq_ValueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_parq_value = /** @type {((inputs: Profile_Parq_ValueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Parq_ValueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_parq_value(inputs)
	if (locale === "es-419") return es_419_profile_parq_value(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_parq_value(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_parq_value(inputs)
	if (locale === "de-DE") return de_de2_profile_parq_value(inputs)
	if (locale === "it-IT") return it_it2_profile_parq_value(inputs)
	return en_us2_profile_parq_value(inputs)
});
export { profile_parq_value as "profile.parq_value" }